import { render, staticRenderFns } from "./OpeningsInputNew.vue?vue&type=template&id=06b33617&scoped=true&"
import script from "./OpeningsInputNew.vue?vue&type=script&lang=js&"
export * from "./OpeningsInputNew.vue?vue&type=script&lang=js&"
import style0 from "./OpeningsInputNew.vue?vue&type=style&index=0&id=06b33617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b33617",
  null
  
)

export default component.exports